import React from 'react';
import HashLoader from 'react-spinners/HashLoader';

const ConsoleLoader = () => {
	return (
		<div
			className="sweet-loading main-container"
			style={{ padding: '10px', width: '100%', height: '120px' }}
		>
			<HashLoader
				color={'#fff'}
				loading={true}
				size={100}
			/>
		</div>
	);
};

export default ConsoleLoader;
